import React, { PropsWithChildren } from 'react';
import styles from './container.module.scss';
import clsx from 'clsx';
interface Props {
    className?: string;
    zIndex?: string | number;
}
export const Container: React.FC<PropsWithChildren<Props>> = ({
    children,
    className,
    zIndex = 'unset',
}) => (
    <div
        style={{ zIndex: zIndex }}
        className={
            clsx(
                styles.container,
                className
            )
        }>{children}</div>
);
